/******/ (() => { // webpackBootstrap
/*!*********************************!*\
  !*** ./resources/js/webview.js ***!
  \*********************************/

$(document).ready(function() {
    window.setTimeout(function() {
        $("#success-alert").fadeTo(500, 0).slideUp(500, function(){
            $(this).remove();
        });
    }, 4000);
});

(function ($) {
  var $body = $('body');
  var locale = $body.data('locale');
  var pt_code = 620;
  $(function () {
    var current = location.pathname;
    $('li.menu-list').click(function () {
      $('li.menu-list').toggleClass('active');

      if ($('li.menu-list').hasClass('active')) {
        $('#sub-menu-i').removeClass('fa-angle-right');
        $('#sub-menu-i').addClass('fa-angle-down');
      } else {
        $('#sub-menu-i').addClass('fa-angle-right');
        $('#sub-menu-i').removeClass('fa-angle-down');
      }
    });
    $(document).ready(function () {
      $('.js-select').select2({
        theme: "default"
      });
    });
    $('.tagsinput').tagsinput({
      tagClass: 'general-label label big'
    });
    $("#date").datepicker({
      weekStart: 1,
      keyboardNavigation: false,
      todayHighlight: true,
      forceParse: false,
      calendarWeeks: true,
      todayBtn: 1,
      autoclose: true,
      format: "dd-mm-yyyy",
      language: locale
    }); // Switcher

    var elems = Array.prototype.slice.call(document.querySelectorAll('.js-switch'));
    elems.forEach(function (html) {
      var switchery = new Switchery(html, {
        color: '#1AB394',
        size: 'default'
      });
    }); // Modals

    $('*[data-show]').modal('show');
  });

  var documentErrorHandler = function () {
    var error = $('#document-error');
    var modal = $('#document-modal');

    if (error !== null && error.val() === 'true') {
      console.log(error.val());
      modal.modal('show');
    }
  }();

  $('a[data-confirm]').on('click', function (e) {
    e.preventDefault();
    var message = $(this).data('confirm');
    var url = $(this).attr('href'); // Show dialogue

    bootbox.confirm({
      size: 'small',
      message: message,
      callback: function callback(confirmed) {
        if (confirmed) {
          window.location.href = url;
        }
      }
    });
  });
  $('form[data-confirm]').on('submit', function (e) {
    e.preventDefault();
    var message = $(this).data('confirm');
    var currentForm = this;
    console.log(message); // Show dialogue

    bootbox.confirm({
      size: 'small',
      message: message,
      callback: function callback(confirmed) {
        if (confirmed) {
          currentForm.submit();
        }
      }
    });
  });
  $('.btn-file :file').on('change', function () {
    var input = $(this),
        numFiles = input.get(0).files ? input.get(0).files.length : 1,
        label = input.val().replace(/\\/g, '/').replace(/.*\//, '');
    input.trigger('fileselect', [numFiles, label]);
  });
  $('.btn-file :file').on('fileselect', function (event, numFiles, label) {
    var input = $(this).parents('.input-group').find(':text'),
        log = numFiles > 1 ? numFiles + ' files selected' : label;

    if (input.length) {
      input.val(log);
    } else {
      // if (log) alert(log);
    }
  });
  /**
   * Prevent enter from submitting form
   */

  $('.prevent-enter').on('keypress keydown keyup', function (e) {
    if (e.which == 13 && !$(e.target).is('textarea')) {
      e.preventDefault();
      return false;
    }
  });
  /*
  |--------------------------------------------------------------------------
  | FUNCTIONS
  |--------------------------------------------------------------------------
  */

    var url = location.href;

    $('.sub-menu').each(function() {
        var $dropdownmenu = $(this);
        $(this).find('li').each(function() {
            if( $(this).find('a').attr('href') == url ) {
                $('.menu-list').addClass("active");
                $(this).find('a').addClass("active-link")
            }
        });
    });

  function getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
  }

})(jQuery);
/******/ })()
;
//# sourceMappingURL=webview.js.map
